import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import {CardAdPricePriceDrop} from './card-ad-price-price-drop.js'
import {getWithoutClass} from './utils.js'

const _getPriceInfoClass = operator => {
  return cx('mt-CardAdPrice-info', {
    'mt-CardAdPrice-info--vertical': operator
  })
}

const _getPriceInfoWarrantyFreeTextClass = ({isWarrantyFreeText, hideLeftBorderInDesktop}) => {
  return cx('mt-CardAdPrice-info', {
    'mt-CardAdPrice-info--warrantyFreeText': isWarrantyFreeText,
    'mt-CardAdPrice-info--hideLeftBorderInDesktop': hideLeftBorderInDesktop
  })
}

export const CardAdPriceInfo = ({
  vertical,
  warrantyLiteral,
  showWarranty,
  taxType,
  includesTaxes,
  isProfessional,
  isWithoutWarranty,
  priceDropData
}) => {
  const {i18n, domain} = useContext(Context)

  const config = domain.get('config')
  const {SHOW_WARRANTY_FREE_TEXT, HIDE_NO_WARRANTY_FREE_TEXT} = config.get('search')

  const hasWarranty = warrantyLiteral !== i18n.t('CARD_AD_NO_WARRANTY')
  const isWarrantyFreeTextOrNoWarranty = SHOW_WARRANTY_FREE_TEXT || HIDE_NO_WARRANTY_FREE_TEXT

  const showTaxType = Boolean(taxType) && isProfessional

  const hasPriceDrop = Boolean(priceDropData)

  const infoClass = isWarrantyFreeTextOrNoWarranty
    ? _getPriceInfoWarrantyFreeTextClass({
        isWarrantyFreeText: isWarrantyFreeTextOrNoWarranty,
        hideLeftBorderInDesktop: HIDE_NO_WARRANTY_FREE_TEXT
      })
    : _getPriceInfoClass(vertical)

  const taxesClass = getWithoutClass({
    className: 'mt-CardAdPrice-infoItem',
    isWithout: !includesTaxes
  })
  const warrantyClass = getWithoutClass({
    className: 'mt-CardAdPrice-infoItem',
    isWithout: isWithoutWarranty && !hasWarranty
  })
  const priceDropClass = getWithoutClass({
    className: 'mt-CardAdPrice-infoItem',
    isWithout: !hasPriceDrop
  })

  return (
    <div className={infoClass}>
      {hasPriceDrop && (
        <span className={priceDropClass}>
          <CardAdPricePriceDrop priceDropData={priceDropData} />
        </span>
      )}
      {showWarranty && hasWarranty && <span className={warrantyClass}>{warrantyLiteral}</span>}
      {showTaxType && <span className={taxesClass}>{`${taxType}`}</span>}
    </div>
  )
}

CardAdPriceInfo.propTypes = {
  vertical: PropTypes.bool,
  warrantyLiteral: PropTypes.string,
  showWarranty: PropTypes.bool,
  taxType: PropTypes.string,
  includesTaxes: PropTypes.bool,
  isWithoutWarranty: PropTypes.bool,
  isProfessional: PropTypes.bool,
  priceDropData: PropTypes.object
}
